var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-status-bar" }, [
    _c(
      "div",
      { staticClass: "status-stages" },
      _vm._l(_vm.statusList, function (stage, index) {
        return _c(
          "div",
          {
            key: stage._id,
            class: [
              "status-stage",
              {
                active: index <= _vm.currentStatusIndex,
                current: index === _vm.currentStatusIndex,
                completed: index < _vm.currentStatusIndex,
              },
            ],
            style: _vm.getStageStyle(index),
            on: {
              click: function ($event) {
                return _vm.updateStatus(index)
              },
            },
          },
          [
            _c("div", { staticClass: "stage-circle" }, [
              index < _vm.currentStatusIndex
                ? _c("span", { staticClass: "material-icons check-icon" }, [
                    _vm._v("\n                    check\n                "),
                  ])
                : _c("span", { staticClass: "stage-number" }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
            ]),
            _vm._v(" "),
            index < _vm.statusList.length - 1
              ? _c("div", {
                  staticClass: "stage-line",
                  style: _vm.getLineStyle(index),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "stage-info" }, [
              _c("div", { staticClass: "stage-name" }, [
                _vm._v(_vm._s(_vm.formatStageName(stage.label || stage.title))),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }